import * as React from 'react';

import StatCard from 'components/Cards/StatCard';
import useLiveData from 'hooks/useLiveData';
import { useStaticQuery, graphql } from 'gatsby';

const StatCardProvider = (props) => {
	const data = useStaticQuery(graphql`
		query statCards {
		  allSmartTagsStatCard {
		    edges {
		      node {
		        id
				flush
				variant
				stat
				name
				info
				link
				icon
		      }
		    }
		  }
		}
	`);
	const {response} = useLiveData({
		namespace: 'SmartTags',
		model: 'StatCard',
		method: 'all',
		staticData: data,
		graphqlKey: 'allSmartTagsStatCard',
	});
	if (response.data.length === 0)return null;
	let attr;
	for (let item of response.data) {
		if (item.id === props.id)attr = item;
	}
	if (!attr)return null;
	return <StatCard {...attr} />
}

export default StatCardProvider;